// ContactUsModalStore.ts
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type ContactAudience = "landlord" | "tenant";

interface ContactUsModalStoreState {
  isVisible: boolean;
  /** Who the public pages opened it for. Signed-in users are told apart by their own login. */
  audience: ContactAudience | null;
  setIsVisible: (isVisible: boolean) => void;
  openFor: (audience: ContactAudience) => void;
}

const useContactUsModalStore = create<ContactUsModalStoreState>()(
  devtools((set) => ({
    isVisible: false,
    audience: null,
    // Opening without an audience forgets the last one; closing keeps it, so
    // the closing animation still shows what was open.
    setIsVisible: (isVisible: boolean) => set(isVisible ? { isVisible, audience: null } : { isVisible }),
    openFor: (audience: ContactAudience) => set({ isVisible: true, audience }),
  }))
);

export default useContactUsModalStore;
